import React, { useState, ReactNode } from 'react'
import { Collapse } from '@material-ui/core'
import { ArrowIcon } from './ArrowIcon'
import { StyledFlexRow } from './styled'

export interface ICollapsePanel {
  summary: ReactNode
  shouldOpen?: boolean
  id?: string
}

export const CollapsePanel: React.FC<ICollapsePanel> = ({
  summary,
  shouldOpen = false,
  id,
  children,
}) => {
  const [expanded, setExpanded] = useState(shouldOpen)
  return (
    <>
      <StyledFlexRow id={id} onClick={() => setExpanded(!expanded)}>
        {summary}
        <ArrowIcon color="primary" up={expanded} />
      </StyledFlexRow>
      <Collapse in={expanded} unmountOnExit>
        {children}
      </Collapse>
    </>
  )
}
